import React, { useEffect, useState, useContext } from 'react'
import { Accordion, List, Card, Tabs, Button, Popover, Checkbox } from 'antd-mobile';

import Permission from '../components/Permission';
import { AclKeys } from '../utils/permissions';
import { Radios, Loading, TitleDescriptions, Descriptions } from '../components';
import { CustomerFilter } from '../components/CommonFilter';
import { CountryFilter } from '../components/CountryFilter';
import ChannelFilter from '../components/ChannelFilter';
import * as Api from "../../../api/usms";
import { ChannelType, ChannelReplaceType, ProtoType, Purpose, UsmsType } from '../utils/const';
import { renderCountryCNameByBrevityCode, ArrRemoveItem } from '../utils/common';
import BasicContext from '../BasicContext';
import { getSmsType, setSmsType } from '../../localStorage';

import ChannelList from './List';
import ChannelConfigEditor from './ChannelConfigEditor';
import IsmsConfigEditorModal from './IsmsConfigEditor';
import BatchReplace from './BatchReplace';

const Item = Popover.Item;
const CheckboxItem = Checkbox.CheckboxItem;

// const SelectPurpose = { ...Purpose, ...{ All: "通用" } };
const SelectPurpose = { ...Purpose };
delete SelectPurpose.All;

const channelTypeOfEN = 2; // 通道类型-国内通道
const channelTypeOfOrganization = 3; // 通道类型-客户通道
const channelTypeOfReplace = 4; // 通道批量替换
const channelReplaceMain = "Main"; // 主通道
const channelTypeForBrevityCode = [2, 3, 4]; // 需要“国家”字段的通道类型
const channelTypeForOrganizationId = [3]; // 需要“项目ID”字段的通道类型
// const brevityCodeOfCN = 'CN'; // 国内通道固定BrevityCode为'CN'
const organizationIdOfNoOrganization = 0; // 非客户通道过滤掉客户配置
// 选择不同通道需要校验的参数
const checkKeysOption = {
  1: ["ProtoType", "Purpose"],
  2: ["ProtoType", "Purpose", "BrevityCode"],
  3: ["ProtoType", "Purpose", "BrevityCode", "OrganizationId"],
  4: ["ProtoType", "Purpose", "BrevityCode"]
};

export default function Channel() {

  const [channelType, setChannelType] = useState(channelTypeOfEN);
  const [protoType, setProtoType] = useState('SMPP');
  const [purpose, setPurpose] = useState('Sale');
  const [brevityCode, setBrevityCode] = useState(['EN']);
  // const [smppAccount, setSmppAccount] = useState();
  const [organizationId, setOrganizationId] = useState([]);
  const [companyInfo, setCompanyInfo] = useState({});
  const [channelReplace, setChannelReplace] = useState(channelReplaceMain)

  const [errorMessage, setErrorMessage] = useState("");

  const [info, setInfo] = useState({});
  const [channelControlList, setChannelControlList] = useState([])
  const [replaceCompanyList, setReplaceCompanyList] = useState([])
  const [companyChecked, setCompanyChecked] = useState([])
  const [loading, setLoading] = useState(false);

  const [initTab, setInitTab] = useState(0);
  const [selectProductVisible, setSelectProductVisible] = useState(false);
  const [newChannel, setNewChannel] = useState("")
  const [isSelectedAll, setIsSelectedAll] = useState(false)

  const context = useContext(BasicContext);
  const customerList = context.customers;
  const countryList = context.countryList || [];
  const smsType = getSmsType();

  const EditorComponent = smsType === 'Text' ? ChannelConfigEditor : IsmsConfigEditorModal;

  const ChannelTypeFilter = smsType === "Text" ? { ...ChannelType, 4: "批量替换" } : ChannelType

  const refreshData = () => {
    getChannelDispatch();
    setInitTab(0);
    clearReplaceData()
  }

  useEffect(() => {
    // 通过用户选择获取企业ID
    if (organizationId && organizationId.length) {
      setCompanyInfo(customerList.find(customer => customer.OrganizationId === organizationId[0]) || {});
    }
  }, [customerList, organizationId]);

  useEffect(() => {
    // 本地调试时组件会被反复挂载两次？
    refreshData();
    // eslint-disable-next-line
  }, [channelType, protoType, purpose, brevityCode, organizationId]);

  // const searchSmpp = () => {
  //   refreshData();
  // }

  const clearReplaceData = () => {
    setNewChannel("")
    setCompanyChecked([])
    setReplaceCompanyList([])
    setChannelReplace(channelReplaceMain)
  }

  const getChannelDispatch = () => {
    const params = {
      ProtoType: protoType,
      BrevityCode: brevityCode[0],
      Purpose: purpose,
      OrganizationId: organizationId
    };
    const validParams = checkParams(channelType, params);
    if (validParams) {
      fetchChannelDispatch({ ...validParams })
    } else (
      setInfo({})
    )
  }

  // 必选参数校验，不同的通道类型，需要的参数不一样，通过校验则返回有效参数并去除多余参数
  const checkParams = (type, params) => {
    if (type) {
      const validParams = {};
      let check = true;
      checkKeysOption[type].forEach(item => {
        validParams[item] = params[item];
        if (!params[item]) {
          check = false;
        }
      });

      // 选择客户通道时必须有organizationId
      if (type === channelTypeOfOrganization) {
        if (!validParams.OrganizationId || validParams.OrganizationId.length <= 0) {
          return false;
        }
      }

      // 当通道类型选择国内时，brevityCode固定CN
      // if (type === channelTypeOfCN) {
      //   validParams.BrevityCode = brevityCodeOfCN;
      // }

      // 当通道类型选择非用户时，需要过滤掉用户的配置
      if (type !== channelTypeOfOrganization && type !== channelTypeOfReplace) {
        validParams.OrganizationId = [organizationIdOfNoOrganization];
      }

      // if (protoType === ProtoType.SMPP && smppAccount) {
      //   validParams.SmppAccount = smppAccount;
      // }

      return check ? validParams : check
    } else {
      return false
    }
  }

  const fetchChannelDispatch = (params) => {
    const data = {}
    Object.keys(params).forEach(item => {
      if (item === 'OrganizationId') {
        data[item] = params[item]
      } else {
        data[item] = [params[item]]
      }
    })
    setLoading(true);
    Api.DescribeChannelControl(data).then(res => {
      if (res.RetCode === 0 && res.Data) {
        setChannelControlList(res.Data)
        setInfo(res.Data[0]);
      } else {
        // 查询不到数据，需要新增，新增时子组件需要的参数统一放info，和修改一个逻辑
        setChannelControlList([])
        setInfo({
          New: true, // 是否需要新建，用来判断新建按钮展示
          ...params
        })
      }
      setLoading(false);
    }).catch(e => setErrorMessage(e.message || "获取数据失败"));
  }

  const infoOptions = (info) => [
    { label: '配置记录ID', value: info.Id },
    { label: '类型', value: UsmsType[info.MsgType] || (smsType === 'Text' ? '文本短信' : '视频短信') },
    { label: '短信类型', value: Purpose[info.Purpose] },
    { label: '协议类型', value: ProtoType[info.ProtoType] },
    { label: '国家/地区', value: renderCountryCNameByBrevityCode(info.BrevityCode, countryList) },
    { label: '备注', value: info.Remark || '-' },
    {
      custom: index => <Accordion key={index} style={{ flex: 1 }}>
        <Accordion.Panel header={<span style={{ fontSize: '15px', marginLeft: '-15px', fontWeight: 500 }}>通道列表：</span>}>
          <List>
            {(info.Channel || []).map((channel, index) => <List.Item key={index}>
              <span style={{ fontSize: '14px', color: '#526075' }}>{channel}</span>
            </List.Item>)}
          </List>
        </Accordion.Panel>
      </Accordion>
    },
  ]

  const tabs = [
    { title: '信息查看' },
    { title: '编辑配置' },
  ];

  // 编辑完成后的收尾工作
  const fetchBack = () => {
    refreshData();
  }

  const handleSelectChannelReplace = (value) => {
    clearReplaceData()
    setChannelReplace(value)
  }

  const handleSelectAll = () => {
    if (!isSelectedAll) {
      const all = replaceCompanyList.map(c => c.Id)
      setCompanyChecked(all)
    } else {
      setCompanyChecked([])
    }
    setIsSelectedAll(!isSelectedAll)
  }

  return (
    <div className="container usms-container">
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h3>{`${smsType === 'Text' ? 'USMS' : 'ISMS'} 通道调度：`}</h3>
        <Popover mask
          overlayStyle={{ color: 'currentColor' }}
          visible={selectProductVisible}
          overlay={[
            (<Item key="Text" value="Text" disabled={smsType === 'Text'}>文本短信USMS</Item>),
            (<Item key="Video" value="Video" disabled={smsType === 'MMS'} style={{ whiteSpace: 'nowrap' }}>彩信MMS</Item>),
          ]}
          align={{
            overflow: { adjustY: 0, adjustX: 0 },
            offset: [-10, 0],
          }}
          onVisibleChange={visible => setSelectProductVisible(visible)}
          onSelect={value => {
            setSmsType(value.key);
          }}
        >
          <Button type="primary" size='small' disabled style={{ fontSize: 12, width: 80 }}>切换产品</Button>
        </Popover>
      </div>
      <Permission aclKey={AclKeys.ChannelConfigTab}>
        <div style={{ marginTop: '10px' }}>
          <span>配置类型：</span>
          <Radios
            value={channelType}
            style={{ whiteSpace: 'nowrap' }}
            onChange={value => setChannelType(value)}
            options={Object.keys(ChannelTypeFilter).map(item => ({ label: ChannelTypeFilter[item], value: +item }))} />
        </div>
        <div style={{ marginTop: '4px' }}>
          <span>协议类型：</span>
          <Radios
            value={protoType}
            style={{ whiteSpace: 'nowrap' }}
            onChange={value => setProtoType(value)}
            options={Object.keys(ProtoType).map(item => ({ label: ProtoType[item], value: item }))} />
        </div>
        <div style={{ marginTop: '4px', marginBottom: channelType === channelTypeOfReplace ? 0 : "20px" }}>
          <span>短信类型：</span>
          <Radios
            value={purpose}
            style={{ whiteSpace: 'nowrap' }}
            onChange={value => setPurpose(value)}
            options={Object.keys(SelectPurpose).map(item => ({ label: SelectPurpose[item], value: item }))} />
        </div>
        {channelType === channelTypeOfReplace ? <div style={{ marginTop: '4px', marginBottom: '20px' }}>
          <span>通道类型：</span>
          <Radios
            value={channelReplace}
            style={{ whiteSpace: 'nowrap' }}
            onChange={value => handleSelectChannelReplace(value)}
            options={Object.keys(ChannelReplaceType).map(item => ({ label: ChannelReplaceType[item], value: item }))} />
        </div> : null}
        <Tabs tabs={tabs}
          page={initTab}
          tabBarPosition={'top'}
          swipeable={false}
          destroyInactiveTab
          onTabClick={(tab, index) => {
            // if (info.Id === undefined || info.Id === null) { Toast.info('请先选择正确的通道信息') }
            setInitTab(index);
          }}
        >
          <div style={{ background: "#f5f5f9" }}>
            {channelTypeForBrevityCode.includes(channelType) ?
              <div style={{ marginTop: '20px' }}>
                <CountryFilter value={brevityCode} onChange={v => setBrevityCode(v)} />
              </div> : null}

            {channelTypeForOrganizationId.includes(channelType) ?
              <div style={{ marginTop: '20px' }}>
                <CustomerFilter value={organizationId} onChange={v => setOrganizationId(v)} />
              </div>
              : null}

            {channelType === channelTypeOfReplace ? <div style={{ marginTop: '20px' }}>
              <ChannelFilter
                value={[newChannel]}
                onChange={val => {
                  if (val && val.length > 0) {
                    const companyList = channelControlList.filter(item => {
                      if (!item.ChannelWeight) return false
                      let channel = []
                      try {
                        const ChannelWeight = JSON.parse(item.ChannelWeight)
                        channel = ChannelWeight.filter(c => c.Type === (channelReplace === "Main" ? 0 : 1)).map(s => s.Channel)
                      } catch (err) {
                        console.log("数据错误", err.message)
                      }
                      return channel.includes(val[0])
                    })
                    setReplaceCompanyList(companyList)
                    setCompanyChecked([])
                    setNewChannel(val[0])
                  }
                }}
              /></div> : null}

            {/* {protoType === ProtoType.SMPP ? (
              <Flex style={{ marginTop: '20px' }} align="center">
                <InputItem placeholder='点击确定搜索SMPP' value={smppAccount} onChange={v => setSmppAccount(v)}>SMPP账号</InputItem>
                <Button size="small" type="primary" style={{ width: '60px', marginLeft: '12px' }} onClick={searchSmpp}>确定</Button>
              </Flex>
            ) : null} */}

            {channelType === channelTypeOfOrganization ?
              <Card style={{ marginTop: '20px' }}>
                <Card.Body>
                  {/* Compass API 有跨域 */}
                  {/* <CompanyInfo OrganizationId={63966219} /> */}
                  <TitleDescriptions
                    title={companyInfo.CompanyName || '无公司名称'}
                    descriptions={[<div>
                      <div>账号ID/BU/等级/当前项目信息:</div>
                      <div>
                        {companyInfo.CompanyId || '-'}{` / `}
                        {companyInfo.BuName || '-'}{` / `}
                        {companyInfo.VipLevel || '-'}{` / `}
                        {`${companyInfo.OrganizationName || '-'}-(${companyInfo.OrganizationId || '-'})-(${companyInfo.OrganizationAlias || '-'})`}{` / `}
                        {/* {companyInfo.SignatureId || '-'}{` / `} */}
                      </div>
                    </div>]} />
                </Card.Body>
              </Card> : null}


            {/*选择要批量替换的公司*/}
            {channelType === channelTypeOfReplace ? <div>
              {replaceCompanyList && replaceCompanyList.length ? <div style={{ marginTop: "20px" }}><Button size="small" type="primary" onClick={() => handleSelectAll()}>{isSelectedAll ? "取消全选" : "全选"}</Button></div> : null}
              <List style={{ marginTop: '10px', overflow: 'auto', maxHeight: '400px' }} renderHeader={() => '请选择要替换通道的公司'}>
                {replaceCompanyList.map(company => (
                  <CheckboxItem checked={companyChecked.includes(company.Id)} key={company.Id} onChange={(selected) => {
                    if (selected.target.checked) {
                      setCompanyChecked([...new Set([...companyChecked, company.Id])])
                    } else {
                      setCompanyChecked(ArrRemoveItem([...new Set(companyChecked)], company.Id))
                    }
                  }}>
                    <TitleDescriptions
                      title={company.CompanyName || '无公司名称'}
                      descriptions={[<div>
                        <div>Id/协议/短信类型/当前项目信息:</div>
                        <div>
                          {company.Id || '-'}{` / `}
                          {company.ProtoType || '-'}{` / `}
                          {SelectPurpose[company.Purpose] || '-'}{` / `}
                          {`${company.OrganizationName || '-'}-(${company.OrganizationId || '-'})-(${company.OrganizationAlias || '-'})`}{` / `}
                        </div>
                      </div>]} />
                  </CheckboxItem>
                ))}
              </List>
            </div> : null}
            {channelType === channelTypeOfReplace && replaceCompanyList.length === 0 ? <Card>
              <p style={{ margin: "36px 0", textAlign: 'center' }}>暂未查询到公司</p>
            </Card> : null}

            <Loading loading={loading} error={errorMessage}>
              {channelType !== channelTypeOfReplace ? <Card style={{ marginTop: '20px' }}>
                <Card.Header title={channelType
                  ? `${ChannelTypeFilter[channelType]}-${Purpose[info.Purpose] || ''
                  }`
                  : '通道配置'} />
                <Card.Body>
                  <Descriptions options={infoOptions(info)} />
                </Card.Body>
              </Card> : null}
              <div style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid #ddd' }}>
                <span>{channelType !== channelTypeOfReplace ? "通道权重配置" : "批量替换配置"}：</span><span className="u-blue" onClick={() => setInitTab(1)}>编辑配置</span>
                {info.Id && channelType !== channelTypeOfReplace ?
                  <ChannelList info={info} /> : null}
              </div>
            </Loading>
          </div>
          <div>
            {initTab === 1 && channelType !== channelTypeOfReplace ?
              <EditorComponent
                info={info}
                channelType={channelType}
                fetchBack={fetchBack}
                searchInfo={{
                  channelType, protoType, purpose, organizationId, companyInfo
                }}
              /> : null}
            {initTab === 1 && channelType === channelTypeOfReplace ? <BatchReplace
              replaceCompanyList={replaceCompanyList}
              newChannel={newChannel}
              companyChecked={companyChecked}
              channelReplace={channelReplace}
              callback={() => clearReplaceData()}
            /> : null}
          </div>
        </Tabs>
      </Permission>
    </div >
  )
}
